export default __webpack_public_path__ + "static/media/satellite.7825fb92.png";